import React, { FC } from 'react'

import styles from './conversationBody.module.scss'

type Props = {
  conversationRef: React.Ref<HTMLDivElement>
  children: React.ReactNode
}

const ConversationBody: FC<Props> = ({ conversationRef, children }) => {
  return (
    <div ref={conversationRef} className={`${styles.conversation}`}>
      {children}
    </div>
  )
}

export { ConversationBody }
